module.exports = __webpack_public_path__ + "img/7.3fe7827d.png";